(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.spinner = factory());
}(this, (function () { 'use strict';

	var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

	function createCommonjsModule(fn, basedir, module) {
		return module = {
			path: basedir,
			exports: {},
			require: function (path, base) {
				return commonjsRequire(path, (base === undefined || base === null) ? module.path : base);
			}
		}, fn(module, module.exports), module.exports;
	}

	function commonjsRequire () {
		throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
	}

	var spinner = createCommonjsModule(function (module, exports) {
	(function (global, factory) {
	  factory(exports) ;
	}(commonjsGlobal, (function (exports) {
	  function _arrayLikeToArray(r, a) {
	    (null == a || a > r.length) && (a = r.length);
	    for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
	    return n;
	  }
	  function _arrayWithHoles(r) {
	    if (Array.isArray(r)) return r;
	  }
	  function _assertThisInitialized(e) {
	    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    return e;
	  }
	  function _callSuper(t, o, e) {
	    return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
	  }
	  function _classCallCheck(a, n) {
	    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
	  }
	  function _defineProperties(e, r) {
	    for (var t = 0; t < r.length; t++) {
	      var o = r[t];
	      o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
	    }
	  }
	  function _createClass(e, r, t) {
	    return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
	      writable: !1
	    }), e;
	  }
	  function _getPrototypeOf(t) {
	    return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
	      return t.__proto__ || Object.getPrototypeOf(t);
	    }, _getPrototypeOf(t);
	  }
	  function _inherits(t, e) {
	    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
	    t.prototype = Object.create(e && e.prototype, {
	      constructor: {
	        value: t,
	        writable: !0,
	        configurable: !0
	      }
	    }), Object.defineProperty(t, "prototype", {
	      writable: !1
	    }), e && _setPrototypeOf(t, e);
	  }
	  function _isNativeReflectConstruct() {
	    try {
	      var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
	    } catch (t) {}
	    return (_isNativeReflectConstruct = function () {
	      return !!t;
	    })();
	  }
	  function _iterableToArrayLimit(r, l) {
	    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
	    if (null != t) {
	      var e,
	        n,
	        i,
	        u,
	        a = [],
	        f = !0,
	        o = !1;
	      try {
	        if (i = (t = t.call(r)).next, 0 === l) {
	          if (Object(t) !== t) return;
	          f = !1;
	        } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
	      } catch (r) {
	        o = !0, n = r;
	      } finally {
	        try {
	          if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
	        } finally {
	          if (o) throw n;
	        }
	      }
	      return a;
	    }
	  }
	  function _nonIterableRest() {
	    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	  }
	  function _possibleConstructorReturn(t, e) {
	    if (e && ("object" == typeof e || "function" == typeof e)) return e;
	    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
	    return _assertThisInitialized(t);
	  }
	  function _setPrototypeOf(t, e) {
	    return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
	      return t.__proto__ = e, t;
	    }, _setPrototypeOf(t, e);
	  }
	  function _slicedToArray(r, e) {
	    return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
	  }
	  function _toPrimitive(t, r) {
	    if ("object" != typeof t || !t) return t;
	    var e = t[Symbol.toPrimitive];
	    if (void 0 !== e) {
	      var i = e.call(t, r || "default");
	      if ("object" != typeof i) return i;
	      throw new TypeError("@@toPrimitive must return a primitive value.");
	    }
	    return ("string" === r ? String : Number)(t);
	  }
	  function _toPropertyKey(t) {
	    var i = _toPrimitive(t, "string");
	    return "symbol" == typeof i ? i : i + "";
	  }
	  function _unsupportedIterableToArray(r, a) {
	    if (r) {
	      if ("string" == typeof r) return _arrayLikeToArray(r, a);
	      var t = {}.toString.call(r).slice(8, -1);
	      return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
	    }
	  }

	  function noop() { }
	  function run(fn) {
	      return fn();
	  }
	  function blank_object() {
	      return Object.create(null);
	  }
	  function run_all(fns) {
	      fns.forEach(run);
	  }
	  function is_function(thing) {
	      return typeof thing === 'function';
	  }
	  function safe_not_equal(a, b) {
	      return a != a ? b == b : a !== b || ((a && typeof a === 'object') || typeof a === 'function');
	  }
	  function is_empty(obj) {
	      return Object.keys(obj).length === 0;
	  }

	  function append(target, node) {
	      target.appendChild(node);
	  }
	  function insert(target, node, anchor) {
	      target.insertBefore(node, anchor || null);
	  }
	  function detach(node) {
	      node.parentNode.removeChild(node);
	  }
	  function element(name) {
	      return document.createElement(name);
	  }
	  function svg_element(name) {
	      return document.createElementNS('http://www.w3.org/2000/svg', name);
	  }
	  function text(data) {
	      return document.createTextNode(data);
	  }
	  function attr(node, attribute, value) {
	      if (value == null)
	          node.removeAttribute(attribute);
	      else if (node.getAttribute(attribute) !== value)
	          node.setAttribute(attribute, value);
	  }
	  function children(element) {
	      return Array.from(element.childNodes);
	  }

	  let current_component;
	  function set_current_component(component) {
	      current_component = component;
	  }

	  const dirty_components = [];
	  const binding_callbacks = [];
	  const render_callbacks = [];
	  const flush_callbacks = [];
	  const resolved_promise = Promise.resolve();
	  let update_scheduled = false;
	  function schedule_update() {
	      if (!update_scheduled) {
	          update_scheduled = true;
	          resolved_promise.then(flush);
	      }
	  }
	  function add_render_callback(fn) {
	      render_callbacks.push(fn);
	  }
	  let flushing = false;
	  const seen_callbacks = new Set();
	  function flush() {
	      if (flushing)
	          return;
	      flushing = true;
	      do {
	          // first, call beforeUpdate functions
	          // and update components
	          for (let i = 0; i < dirty_components.length; i += 1) {
	              const component = dirty_components[i];
	              set_current_component(component);
	              update(component.$$);
	          }
	          set_current_component(null);
	          dirty_components.length = 0;
	          while (binding_callbacks.length)
	              binding_callbacks.pop()();
	          // then, once components are updated, call
	          // afterUpdate functions. This may cause
	          // subsequent updates...
	          for (let i = 0; i < render_callbacks.length; i += 1) {
	              const callback = render_callbacks[i];
	              if (!seen_callbacks.has(callback)) {
	                  // ...so guard against infinite loops
	                  seen_callbacks.add(callback);
	                  callback();
	              }
	          }
	          render_callbacks.length = 0;
	      } while (dirty_components.length);
	      while (flush_callbacks.length) {
	          flush_callbacks.pop()();
	      }
	      update_scheduled = false;
	      flushing = false;
	      seen_callbacks.clear();
	  }
	  function update($$) {
	      if ($$.fragment !== null) {
	          $$.update();
	          run_all($$.before_update);
	          const dirty = $$.dirty;
	          $$.dirty = [-1];
	          $$.fragment && $$.fragment.p($$.ctx, dirty);
	          $$.after_update.forEach(add_render_callback);
	      }
	  }
	  const outroing = new Set();
	  function transition_in(block, local) {
	      if (block && block.i) {
	          outroing.delete(block);
	          block.i(local);
	      }
	  }
	  function mount_component(component, target, anchor, customElement) {
	      const { fragment, on_mount, on_destroy, after_update } = component.$$;
	      fragment && fragment.m(target, anchor);
	      if (!customElement) {
	          // onMount happens before the initial afterUpdate
	          add_render_callback(() => {
	              const new_on_destroy = on_mount.map(run).filter(is_function);
	              if (on_destroy) {
	                  on_destroy.push(...new_on_destroy);
	              }
	              else {
	                  // Edge case - component was destroyed immediately,
	                  // most likely as a result of a binding initialising
	                  run_all(new_on_destroy);
	              }
	              component.$$.on_mount = [];
	          });
	      }
	      after_update.forEach(add_render_callback);
	  }
	  function destroy_component(component, detaching) {
	      const $$ = component.$$;
	      if ($$.fragment !== null) {
	          run_all($$.on_destroy);
	          $$.fragment && $$.fragment.d(detaching);
	          // TODO null out other refs, including component.$$ (but need to
	          // preserve final state?)
	          $$.on_destroy = $$.fragment = null;
	          $$.ctx = [];
	      }
	  }
	  function make_dirty(component, i) {
	      if (component.$$.dirty[0] === -1) {
	          dirty_components.push(component);
	          schedule_update();
	          component.$$.dirty.fill(0);
	      }
	      component.$$.dirty[(i / 31) | 0] |= (1 << (i % 31));
	  }
	  function init(component, options, instance, create_fragment, not_equal, props, dirty = [-1]) {
	      const parent_component = current_component;
	      set_current_component(component);
	      const $$ = component.$$ = {
	          fragment: null,
	          ctx: null,
	          // state
	          props,
	          update: noop,
	          not_equal,
	          bound: blank_object(),
	          // lifecycle
	          on_mount: [],
	          on_destroy: [],
	          on_disconnect: [],
	          before_update: [],
	          after_update: [],
	          context: new Map(parent_component ? parent_component.$$.context : options.context || []),
	          // everything else
	          callbacks: blank_object(),
	          dirty,
	          skip_bound: false
	      };
	      let ready = false;
	      $$.ctx = instance
	          ? instance(component, options.props || {}, (i, ret, ...rest) => {
	              const value = rest.length ? rest[0] : ret;
	              if ($$.ctx && not_equal($$.ctx[i], $$.ctx[i] = value)) {
	                  if (!$$.skip_bound && $$.bound[i])
	                      $$.bound[i](value);
	                  if (ready)
	                      make_dirty(component, i);
	              }
	              return ret;
	          })
	          : [];
	      $$.update();
	      ready = true;
	      run_all($$.before_update);
	      // `false` as a special case of no DOM component
	      $$.fragment = create_fragment ? create_fragment($$.ctx) : false;
	      if (options.target) {
	          if (options.hydrate) {
	              const nodes = children(options.target);
	              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
	              $$.fragment && $$.fragment.l(nodes);
	              nodes.forEach(detach);
	          }
	          else {
	              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
	              $$.fragment && $$.fragment.c();
	          }
	          if (options.intro)
	              transition_in(component.$$.fragment);
	          mount_component(component, options.target, options.anchor, options.customElement);
	          flush();
	      }
	      set_current_component(parent_component);
	  }
	  /**
	   * Base class for Svelte components. Used when dev=false.
	   */
	  class SvelteComponent {
	      $destroy() {
	          destroy_component(this, 1);
	          this.$destroy = noop;
	      }
	      $on(type, callback) {
	          const callbacks = (this.$$.callbacks[type] || (this.$$.callbacks[type] = []));
	          callbacks.push(callback);
	          return () => {
	              const index = callbacks.indexOf(callback);
	              if (index !== -1)
	                  callbacks.splice(index, 1);
	          };
	      }
	      $set($$props) {
	          if (this.$$set && !is_empty($$props)) {
	              this.$$.skip_bound = true;
	              this.$$set($$props);
	              this.$$.skip_bound = false;
	          }
	      }
	  }

	  function create_else_block(ctx) {
	    var svg;
	    var rect;
	    var circle;
	    var animateTransform;
	    return {
	      c: function c() {
	        svg = svg_element("svg");
	        rect = svg_element("rect");
	        circle = svg_element("circle");
	        animateTransform = svg_element("animateTransform");
	        attr(rect, "x", "0");
	        attr(rect, "y", "0");
	        attr(rect, "width", "100");
	        attr(rect, "height", "100");
	        attr(rect, "fill", "none");
	        attr(rect, "class", "bk");
	        attr(animateTransform, "attributeName", "transform");
	        attr(animateTransform, "type", "rotate");
	        attr(animateTransform, "values", "0 50 50;180 50 50;360 50 50;");
	        attr(animateTransform, "keyTimes", "0;0.5;1");
	        attr(animateTransform, "dur", "1s");
	        attr(animateTransform, "repeatCount", "indefinite");
	        attr(animateTransform, "begin", "0s");
	        attr(circle, "cx", "50");
	        attr(circle, "cy", "50");
	        attr(circle, "r", "42.5");
	        attr(circle, "stroke-dasharray", "173.57299411083608 93.46238144429634");
	        attr(circle, "stroke", "currentColor");
	        attr(circle, "fill", "none");
	        attr(circle, "stroke-width", "15");
	        attr(svg, "style", /*_style*/ctx[0]);
	        attr(svg, "fill", "currentColor");
	        attr(svg, "xmlns", "http://www.w3.org/2000/svg");
	        attr(svg, "viewBox", "0 0 100 100");
	        attr(svg, "preserveAspectRatio", "xMidYMid");
	        attr(svg, "class", "uil-ring");
	      },
	      m: function m(target, anchor) {
	        insert(target, svg, anchor);
	        append(svg, rect);
	        append(svg, circle);
	        append(circle, animateTransform);
	      },
	      p: function p(ctx, dirty) {
	        if (dirty & /*_style*/1) {
	          attr(svg, "style", /*_style*/ctx[0]);
	        }
	      },
	      d: function d(detaching) {
	        if (detaching) detach(svg);
	      }
	    };
	  }

	  // (2:2) {#if mode === 'printos'}
	  function create_if_block(ctx) {
	    var svg;
	    var style;
	    var t;
	    var path0;
	    var path1;
	    var g;
	    var circle;
	    return {
	      c: function c() {
	        svg = svg_element("svg");
	        style = svg_element("style");
	        t = text("@-webkit-keyframes el_3R6WG92ED-_9z4k3l2Lz_Animation{0%{-webkit-transform: translate(50px, 67.33000183105469px) rotate(0deg) translate(-50px, -67.33000183105469px);transform: translate(50px, 67.33000183105469px) rotate(0deg) translate(-50px, -67.33000183105469px);}100%{-webkit-transform: translate(50px, 67.33000183105469px) rotate(1080deg) translate(-50px, -67.33000183105469px);transform: translate(50px, 67.33000183105469px) rotate(1080deg) translate(-50px, -67.33000183105469px);}}@keyframes el_3R6WG92ED-_9z4k3l2Lz_Animation{0%{-webkit-transform: translate(50px, 67.33000183105469px) rotate(0deg) translate(-50px, -67.33000183105469px);transform: translate(50px, 67.33000183105469px) rotate(0deg) translate(-50px, -67.33000183105469px);}100%{-webkit-transform: translate(50px, 67.33000183105469px) rotate(1080deg) translate(-50px, -67.33000183105469px);transform: translate(50px, 67.33000183105469px) rotate(1080deg) translate(-50px, -67.33000183105469px);}}#el_ztyBp85wH *{-webkit-animation-duration: 3s;animation-duration: 3s;-webkit-animation-iteration-count: infinite;animation-iteration-count: infinite;-webkit-animation-timing-function: cubic-bezier(0, 0, 1, 1);animation-timing-function: cubic-bezier(0, 0, 1, 1);}#el_OK7WH8ppuY{fill: currentColor;}#el_pzIR5oVpeo{fill: currentColor;}#el_3R6WG92ED-{fill: none;stroke: currentColor;stroke-width: 5;}#el_3R6WG92ED-_9z4k3l2Lz{-webkit-animation-name: el_3R6WG92ED-_9z4k3l2Lz_Animation;animation-name: el_3R6WG92ED-_9z4k3l2Lz_Animation;}");
	        path0 = svg_element("path");
	        path1 = svg_element("path");
	        g = svg_element("g");
	        circle = svg_element("circle");
	        attr(path0, "d", "M67,70V64.67l-3.53-.91a14.62,14.62,0,0,0-1.41-3.41L64,57.25l-3.73-3.82-3.13,1.91a21,21,0,0,0-3.43-1.5l-.91-3.51H47.33l-.91,3.51A13,13,0,0,0,43,55.24l-3.13-1.91-3.73,3.82L38,60.25a17.89,17.89,0,0,0-1.51,3.41L33,64.57V70l3.53.91a14.62,14.62,0,0,0,1.41,3.41L36,77.4l3.73,3.82,3.13-1.91a21,21,0,0,0,3.43,1.5l.91,3.52h5.44l.91-3.52A13,13,0,0,0,57,79.41l3.13,1.91L64,77.61,62.06,74.5a17.89,17.89,0,0,0,1.51-3.41ZM49.85,76.7a9.48,9.48,0,1,1,9.58-9.43A9.47,9.47,0,0,1,49.85,76.7Z");
	        attr(path0, "id", "el_OK7WH8ppuY");
	        attr(path1, "d", "M92.5,39.38h0a14,14,0,0,0-3.3-.91A19.08,19.08,0,0,0,78,24.77a18.87,18.87,0,0,0-7.6-1.6,20.32,20.32,0,0,0-5.5.8A24.09,24.09,0,0,0,51.7,9.67a24.54,24.54,0,0,0-9.5-2,24.37,24.37,0,0,0-22,14.4A19.84,19.84,0,0,0,18.9,26h-.2A18.34,18.34,0,0,0,2.1,36.67a17.78,17.78,0,0,0,9.3,23.5,18.62,18.62,0,0,0,6.9,1.5h.2c.3-1.6.7-3.1,1.1-4.6H18.5A12.61,12.61,0,0,1,13.2,56a13.33,13.33,0,0,1-8-12.09,14,14,0,0,1,1.1-5.3,13.37,13.37,0,0,1,12.2-8,10.87,10.87,0,0,1,1.8.1l2.3.3.3-2.3a15.65,15.65,0,0,1,1.4-4.8,19.07,19.07,0,0,1,17.8-11.5A19.34,19.34,0,0,1,49.8,14,19.61,19.61,0,0,1,61,27.48l.6,2.8L64.1,29a14.24,14.24,0,0,1,6.1-1.3,15.07,15.07,0,0,1,5.8,1.2,14.62,14.62,0,0,1,8.8,12l.2,2.3L87.3,43h.6a8.87,8.87,0,0,1,2.7.5,7,7,0,0,1,4.2,6.41,7.43,7.43,0,0,1-6.2,7.2h-7a39,39,0,0,1,1.2,4.6h6.1a11.75,11.75,0,0,0,9.5-7.1,12.7,12.7,0,0,0,1-4.6A11.14,11.14,0,0,0,92.5,39.38Z");
	        attr(path1, "id", "el_pzIR5oVpeo");
	        attr(circle, "cx", "50");
	        attr(circle, "cy", "67.33");
	        attr(circle, "r", "25");
	        attr(circle, "stroke-dasharray", "55");
	        attr(circle, "id", "el_3R6WG92ED-");
	        attr(g, "id", "el_3R6WG92ED-_9z4k3l2Lz");
	        attr(g, "data-animator-group", "true");
	        attr(g, "data-animator-type", "1");
	        attr(svg, "style", /*_style*/ctx[0]);
	        attr(svg, "id", "el_ztyBp85wH");
	        attr(svg, "data-name", "Layer 1");
	        attr(svg, "xmlns", "http://www.w3.org/2000/svg");
	        attr(svg, "viewBox", "0 0 100 100");
	      },
	      m: function m(target, anchor) {
	        insert(target, svg, anchor);
	        append(svg, style);
	        append(style, t);
	        append(svg, path0);
	        append(svg, path1);
	        append(svg, g);
	        append(g, circle);
	      },
	      p: function p(ctx, dirty) {
	        if (dirty & /*_style*/1) {
	          attr(svg, "style", /*_style*/ctx[0]);
	        }
	      },
	      d: function d(detaching) {
	        if (detaching) detach(svg);
	      }
	    };
	  }
	  function create_fragment(ctx) {
	    var div;
	    function select_block_type(ctx, dirty) {
	      if (/*mode*/ctx[1] === "printos") return create_if_block;
	      return create_else_block;
	    }
	    var current_block_type = select_block_type(ctx);
	    var if_block = current_block_type(ctx);
	    return {
	      c: function c() {
	        div = element("div");
	        if_block.c();
	        attr(div, "class", "pros-spinner");
	      },
	      m: function m(target, anchor) {
	        insert(target, div, anchor);
	        if_block.m(div, null);
	      },
	      p: function p(ctx, _ref) {
	        var _ref2 = _slicedToArray(_ref, 1),
	          dirty = _ref2[0];
	        if (current_block_type === (current_block_type = select_block_type(ctx)) && if_block) {
	          if_block.p(ctx, dirty);
	        } else {
	          if_block.d(1);
	          if_block = current_block_type(ctx);
	          if (if_block) {
	            if_block.c();
	            if_block.m(div, null);
	          }
	        }
	      },
	      i: noop,
	      o: noop,
	      d: function d(detaching) {
	        if (detaching) detach(div);
	        if_block.d();
	      }
	    };
	  }
	  function instance($$self, $$props, $$invalidate) {
	    var _$$props$diameter = $$props.diameter,
	      diameter = _$$props$diameter === void 0 ? null : _$$props$diameter;
	    var _$$props$mode = $$props.mode,
	      mode = _$$props$mode === void 0 ? null : _$$props$mode;
	    var _$$props$color = $$props.color,
	      color = _$$props$color === void 0 ? null : _$$props$color;
	    var _$$props$_style = $$props._style,
	      _style = _$$props$_style === void 0 ? "" : _$$props$_style;
	    var _$$props$_diameter = $$props._diameter,
	      _diameter = _$$props$_diameter === void 0 ? null : _$$props$_diameter;
	    $$self.$$set = function ($$props) {
	      if ("diameter" in $$props) $$invalidate(3, diameter = $$props.diameter);
	      if ("mode" in $$props) $$invalidate(1, mode = $$props.mode);
	      if ("color" in $$props) $$invalidate(4, color = $$props.color);
	      if ("_style" in $$props) $$invalidate(0, _style = $$props._style);
	      if ("_diameter" in $$props) $$invalidate(2, _diameter = $$props._diameter);
	    };
	    $$self.$$.update = function () {
	      if ($$self.$$.dirty & /*diameter, _diameter, mode, _style, color*/31) {
	        {
	          $$invalidate(2, _diameter = diameter ? Number(diameter) : null);
	          if (!_diameter) {
	            $$invalidate(2, _diameter = mode === "printos" ? 200 : 50);
	          }
	          $$invalidate(0, _style = "height:".concat(_diameter, "px;width:").concat(_diameter, "px;"));
	          $$invalidate(0, _style += color ? "color:".concat(color, ";") : "color:#0096d6;");
	        }
	      }
	    };
	    return [_style, mode, _diameter, diameter, color];
	  }
	  var Spinner = /*#__PURE__*/function (_SvelteComponent) {
	    function Spinner(options) {
	      var _this;
	      _classCallCheck(this, Spinner);
	      _this = _callSuper(this, Spinner);
	      init(_this, options, instance, create_fragment, safe_not_equal, {
	        diameter: 3,
	        mode: 1,
	        color: 4,
	        _style: 0,
	        _diameter: 2
	      });
	      return _this;
	    }
	    _inherits(Spinner, _SvelteComponent);
	    return _createClass(Spinner);
	  }(SvelteComponent);

	  exports.Spinner = Spinner;

	  Object.defineProperty(exports, '__esModule', { value: true });

	})));
	});

	var name = 'prosSpinner';
	function prosSpinner() {
	  'ngInject';

	  var directive = {
	    restrict: 'EA',
	    scope: {
	      mode: '=',
	      diameter: '=?',
	      color: '=?',
	      id: '@'
	    },
	    link: spinnerLink,
	    controller: spinnerController,
	    controllerAs: 'vm',
	    bindToController: true
	  };
	  return directive;

	  //////////////////////

	  function spinnerLink(scope, element, attrs) {
	    scope.vm.spinner = new spinner.Spinner({
	      target: element[0],
	      props: {
	        mode: scope.vm.mode,
	        diameter: scope.vm.diameter,
	        id: scope.vm.id,
	        color: scope.vm.color
	      }
	    });
	    scope.$watch('vm.id', function (id) {
	      scope.vm.spinner.$set({
	        id: id
	      });
	    });
	    scope.$watch('vm.color', function (color) {
	      scope.vm.spinner.$set({
	        color: color
	      });
	    });
	    scope.$watch('vm.mode', function (mode) {
	      scope.vm.spinner.$set({
	        mode: mode
	      });
	    });
	    scope.$watch('vm.diameter', function (diameter) {
	      scope.vm.spinner.$set({
	        diameter: diameter
	      });
	    });
	  }

	  /** @ngInject */
	  function spinnerController() {
	    var vm = this;
	    vm.$onInit = onInit;
	    return;
	    function onInit() {}
	  }
	}

	var spinner_module = angular.module('printos.spinner', []).directive(name, prosSpinner).name;

	return spinner_module;

})));
